import { PropsWithChildren } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import {
  ISectionHeaderProps,
  SectionHeader,
} from "../SectionHeader/SectionHeader";

export const TitledSection: React.FC<ITitledSectionProps> = ({
  title,
  endAdornment,
  children,
  className,
  style,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Box
      className={cx(classes.titledSectionContainer, className)}
      style={style}
    >
      <SectionHeader title={title} endAdornment={endAdornment} />
      {children}
    </Box>
  );
};

interface ITitledSectionProps extends ISectionHeaderProps, PropsWithChildren {
  className?: string;
  style?: React.CSSProperties;
}

const useStyles = makeStyles()((theme) => ({
  titledSectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    flex: 1,
    flexShrink: 2,
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(4),
    borderRadius: 4,
    minWidth: 0,
  },
}));
